import { RacingStore } from "../../../data/store";
export class RacingCombinedViewData {
    constructor(provider, nextRacesCount, appNavigation) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingStore.nextRacesCount = nextRacesCount;
        this.racingStore.appNavigation = appNavigation;
    }
    setParams(regionId, branchId) {
        this.racingStore.setParams(regionId, branchId);
    }
    deactivate() {
        this.racingStore.clear();
    }
}
//# sourceMappingURL=RacingCombinedViewData.js.map